import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";
import CONSTANT from "../../constant";
import { getCookie, onChange, setValue } from "../../utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddCircular, AddCircularAttachment } from "../../actions/Circular";
import constant from "../../constant";
import Loader from "../../component/common/Loader";
import {
  addPropertyReturn,
  getPropertyReturnList,
  getPropertyReturnListForHr,
  updatePropertyReturnStatus,
} from "../../actions/property_retrun";
import HrHeader from "../../component/common/HrHeader";
import moment from "moment";

export default class HrPropertyReturnList extends Component {
  constructor(props) {
    super(props);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    this.state = {
      userDetail,
      list: undefined,
      showLoader: false,
      formSubmitted: false,
      filters: {
        financialYear: "",
        employeeCode: "",
      },
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFileBlur = this.onFileBlur.bind(this);
    this.successMessage = this.successMessage.bind(this);
    this.erroMessage = this.erroMessage.bind(this);
     this.onSerach = this.onSerach.bind(this);
  }

  componentDidMount() {
    this.fetchPropertyReturnList();
  }

  onFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }));
  };

  onSerach = (e) => {
  e.preventDefault();
  this.fetchPropertyReturnList();
};


  fetchPropertyReturnList = () => {
    const { financialYear, employeeCode } = this.state.filters;
    this.setState({ showLoader: true });

    let model = {
      financialYear,
      employeeCode,
    };
    getPropertyReturnListForHr(model)
      .then((data) => {
        this.setState({
          list: data.result || [],
          showLoader: false,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch property return list:", error);
        this.setState({ showLoader: false });
      });
  };

  handleStatusChange = async (item, value) => {
    try {
      this.setState({ showLoader: true });

      // 1. Call update API
      await updatePropertyReturnStatus({
        id: item.id,
        status: value,
      });

      // 2. Fetch latest data
      const data = await getPropertyReturnListForHr();
      // 3. Update state → re-render
      this.setState({ list: data.result || [] });
      toast.success("Status updated successfully");
    } catch (error) {
      console.error("Status update failed:", error);
    } finally {
      // ✅ Always stop loader
      this.setState({ showLoader: false });
    }
  };

  onChange(e) {
    const { name, value, files } = e.target;
    const { Uploads, yearofProperty } = this.state;

    if (name === Uploads.name && files) {
      // Reset error when files are selected
      this.setState({
        ...this.state,
        Uploads: {
          ...Uploads,
          value: files,
          error: "",
          touched: true,
        },
      });
    } else if (name === "financialYear") {
      // Handle year selection - map to yearofProperty
      this.setState({
        ...this.state,
        yearofProperty: { ...yearofProperty, value: value, error: "" },
      });
    } else {
      this.setState({
        ...this.state,
        [name]: { ...this.state[name], value: value, error: "" },
      });
    }
  }

  onFileBlur(e) {
    const { Uploads } = this.state;
    const { name } = e.target;

    if (name === Uploads.name) {
      this.setState({
        ...this.state,
        Uploads: { ...Uploads, touched: true },
      });
    }
  }

  onBlur(e) {
    const { name, value } = e.target;

    // Handle the year field blur (which has name="financialYear" in the select)
    if (name === "financialYear") {
      const { yearofProperty } = this.state;
      if (yearofProperty.isRequired && !value) {
        this.setState({
          ...this.state,
          yearofProperty: { ...yearofProperty, error: "Year is required" },
        });
      }
    }
    // For other fields that might be added later
    else {
      const field = this.state[name];
      if (field && field.isRequired && !value) {
        this.setState({
          ...this.state,
          [name]: { ...field, error: "This field is required" },
        });
      }
    }
  }

  render() {
    const { showLoader, yearofProperty, Uploads, formSubmitted, list } =
      this.state;
    return (
      <React.Fragment>
        {showLoader && <Loader />}

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2 px-0">
              <HrHeader />
            </div>
            <div className="col-md-10">
              <div className="card homedob p-4 mb-4">
                <div className="row">
                  <div className="col-md-8">
                    <h3 className="page-title">Property Return List</h3>
                  </div>

                  <div className="col-md-4 text-end">
                    <Link
                      to={CONSTANT.component.userFileList.url}
                      className="btn-back-home"
                    >
                      <h2> Go Back </h2>
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="employeeCode"
                      value={this.state.filters.employeeCode}
                      onChange={this.onFilterChange}
                      className="form-control"
                      placeholder="Search by Employee Code"
                    />
                  </div>

                  <div className="col-md-4">
                    <select
                      name="financialYear"
                      value={this.state.filters.financialYear}
                      onChange={this.onFilterChange}
                      className="form-control"
                    >
                      <option value="">Select Financial Year</option>
                      <option value="2025">2025</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <button
                      name="search"
                      onClick={this.onSerach}
                      className="form-control"
                    >Search</button>
                  </div>
                </div>

                <div className="row">
                  <div className="row pt-4">
                    <div className="col-12">
                      {this.state.list && this.state.list.length > 0 ? (
                        <table className="table table-bordered">
                          <thead className="head-bold">
                            <tr className="font-bold">
                              <th>#</th>
                              <th>Employee Number</th>
                              <th>Name</th>
                              <th>Year of Property</th>
                              <th>File Name</th>
                              <th>File URL</th>
                              <th>Created On</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.list.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.employeeNumber}</td>
                                <td>{item?.name}</td>
                                <td>{item?.year_of_property}</td>
                                <td>{item?.file_name}</td>
                                <td>
                                  <a
                                    href={`${process.env.REACT_APP_BASE_URL}property_doc/${item.file_url}`.replace(
                                      "v1/",
                                      ""
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {item?.file_url}
                                  </a>
                                </td>
                                <td>{moment(item?.created_at).format("DD-MM-YYYY")}</td>
                                <td>
                                  <select
                                    className="form-control"
                                    value={item?.status}
                                    onChange={(e) =>
                                      this.handleStatusChange(
                                        item,
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="PENDING">PENDING</option>
                                    <option value="RECEIVED">RECEIVED</option>
                                    <option value="RETURN">RETURN</option>
                                  </select>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div>No records found.</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    );
  }

  erroMessage(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  successMessage(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
}
